import { useToast } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { useVerifyUserMutation } from "../../store/api";
import { Spinner } from "@chakra-ui/spinner";
import { Box, Grid, Heading, Text, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
const EmailVerify = () => {
  const { token } = useParams();
  const toast = useToast();
  const navigate = useNavigate();

  const [verifyUser, { data, isError, isLoading, error, isSuccess }] =
    useVerifyUserMutation();
  if (isError) {
    toast({
      title: (error as any)?.data?.message,
      status: "error",
      duration: 5000,
    });
  }
  console.log(data);

  useEffect(() => {
    if (token) {
      verifyUser({ token });
    }
  }, [verifyUser, token]);
  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {isError && (
            <Grid placeItems="center" h="50vh">
              <Text color="red">Email Verification Failed! due to { (error as any)?.data?.message}</Text>
              <Button
                colorScheme="teal"
                color="white"
                variant="solid"
                onClick={() =>
                  navigate('/signup')
                }
              >
                Back to Sign up
              </Button>
            </Grid>
          )}
          {isSuccess && (
            <Box textAlign="center" py={10} px={6}>
              <Heading
                display="inline-block"
                as="h2"
                size="2xl"
                bgGradient="linear(to-r, teal.400, teal.600)"
                backgroundClip="text">
                Congratulation! Your account is successfully verified.
              </Heading>
              <Button
                colorScheme="teal"
                bgGradient="linear(to-r, teal.400, teal.500, teal.600)"
                color="white"
                variant="solid"
                onClick={() =>
                  navigate('/signin')
                }
              >
                Go to Sign in
              </Button>
            </Box>
          )}
        </>
      )}
    </>
  );
};

export default EmailVerify;

